export * from "./PurplePresentIcon";
